import loader from "../assets/svg_shape/loader.svg";

export const svgShapes = {
    loader,
};
